import React, { useEffect, useState } from 'react';
import styles from './sticky-cta.module.scss';
import { DefaultButton } from 'shared/ui';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';

export const StickyCTA: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const pricingSection = document.getElementById('landing-pricing');
      if (pricingSection) {
        const rect = pricingSection.getBoundingClientRect();
        setVisible(rect.top < window.innerHeight && rect.bottom < 0);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => navigate(AppLinks.SignUpLink);

  return (
    <div
      className={`${styles.sticky_cta} ${visible ? styles['sticky_cta--visible'] : ''}`}
    >
      <div className={styles.sticky_cta__inner}>
        <div className={styles.sticky_cta__text}>
          <span className={styles.text__title}>
            30 дней бесплатно для 2 сотрудников
          </span>
          <span className={styles.text__subtitle}>
            2 сотрудника, все функции без ограничений
          </span>
        </div>
        <div className={styles.sticky_cta__cta}>
          <DefaultButton
            buttonText="Попробовать бесплатно"
            color="green"
            onClick={handleClick}
          />
        </div>
      </div>
    </div>
  );
};
